import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 40px;
  border-right: 1px solid ${({ theme }) => theme.pallette.silver.light};
  margin-right: 40px;
  gap: 5px;
`;

export const Title = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.pallette.silver.dark};
`;

export const SubTitle = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.pallette.silver.dark};
`;
export const TooltipText = styled.p`
  color: ${({ theme }) => theme.pallette.blue.primary};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;
